<script setup>
const props = defineProps({
  userInfo: {
    type: Object,
    required: true,
  },
});

const emits = defineEmits([]);

const authStore = useAuthStore();
const userStore = useUserStore();

const holdersDialog = ref(false);
const holdersList = ref([]);
const loading = ref(false);
const totalHolders = ref(0);

onMounted(() => {});

const openDialog = async () => {
  holdersDialog.value = true;

  await fetchData();
};

const closeDialog = () => {
  clearState();

  holdersDialog.value = false;
};

const fetchData = async () => {
  try {
    loading.value = true;
    const { data, pagination } = await getSubjectHolder(props.userInfo?.uid);
    holdersList.value = data || [];
    totalHolders.value = pagination?.total || 0;
  } catch (error) {
    console.error("Error fetching data:", error);
  } finally {
    loading.value = false;
  }
};

const clearState = () => {
  holdersList.value = [];
  totalHolders.value = 0;
  loading.value = false;
};

defineExpose({ openDialog, holdersDialog, closeDialog });
</script>

<template>
  <v-dialog
    v-model="holdersDialog"
    class="tw-rounded-2xl !tw-z-[2010]"
    width="540"
    height="500"
    persistent
    scrim="#000"
    opacity="0.5"
  >
    <dialog-close-btn
      :icon="'mdi-close-circle-outline'"
      :iconSize="'32'"
      @onSubmitButton="closeDialog"
    />

    <v-card
      class="!tw-rounded-2xl tw-px-4 tw-py-2 tw-overflow-hidden"
      min-height="196"
      color="container"
      :loading="loading"
    >
      <v-card-title class="tw-text-center tw-p-0 tw-text-base !tw-font-bold">
        HOLDERS: {{ totalHolders }}
      </v-card-title>

      <v-card-text class="!tw-px-0 !tw-text-sm tw-overflow-hidden">
        <v-list class="!tw-bg-transparent" v-if="holdersList.length">
          <v-list-item>
            <template v-slot:append>
              <span class="tw-font-bold tw-text-xs"># Hold </span>
            </template>
          </v-list-item>
          <holder
            v-for="holder in holdersList"
            :key="holder.id"
            :holder="holder"
          />
        </v-list>

        <div
          v-else
          class="tw-font-bold tw-flex tw-justify-center tw-items-center tw-w-full tw-h-full"
        >
          No one holds the user sigil
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
